import moment, { Moment } from "moment";
import { DropAreaPoint } from "../types/DropAreaPoint";
import { DropArea } from "../types/DropArea";

export function getDayDropAreas(day: Moment, points: DropAreaPoint[]) {
	const dropAreas: DropArea[] = [];

	points.forEach((leftPoint, index) => {
		const rightPoint = points[index + 1];

		if (rightPoint && !rightPoint.isEnd) {
			dropAreas.push({
				start: day.clone().add(leftPoint.minute, "minutes"),
				end: day.clone().add(rightPoint.minute, "minutes"),
			});
		}
	});

	return dropAreas;
}

export function getDayDropAreasWithHourSplitting(day: Moment, points: DropAreaPoint[]) {
	const dropAreas: DropArea[] = [];

	points.forEach((leftPoint, index) => {
		const rightPoint = points[index + 1];

		if (rightPoint && !rightPoint.isEnd) {
			const startTime = day.clone().add(leftPoint.minute, "minutes");
			const endTime = day.clone().add(rightPoint.minute, "minutes");
			
			// If the drop area spans multiple hours, split it at hour boundaries
			const startHour = Math.floor(leftPoint.minute / 60);
			const endHour = Math.floor(rightPoint.minute / 60);
			
			if (startHour === endHour) {
				// Within a single hour, keep as is
				dropAreas.push({
					start: startTime,
					end: endTime,
				});
			} else {
				// Spans multiple hours, split at hour boundaries
				let currentStart = startTime.clone();
				
				for (let hour = startHour; hour <= endHour; hour++) {
					const hourBoundary = day.clone().startOf('day').add(hour + 1, 'hours');
					const segmentEnd = hour === endHour ? endTime : moment.min(hourBoundary, endTime);
					
					if (currentStart.isBefore(segmentEnd)) {
						dropAreas.push({
							start: currentStart,
							end: segmentEnd,
						});
					}
					
					currentStart = hourBoundary.clone();
				}
			}
		}
	});

	return dropAreas;
}
